import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, PlusIcon, MinusIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const faqs = [{
  question: '¿Necesito experiencia previa en publicidad?',
  answer: 'No, el curso está diseñado para principiantes. Empezamos desde cero y te guiamos paso a paso. Si ya tienes algo de experiencia, los módulos avanzados te ayudarán a mejorar tus resultados.'
}];
interface FaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FaqItem({
  question,
  answer,
  isOpen,
  onToggle
}: FaqItemProps) {
  return <div className="overflow-hidden rounded-2xl bg-white shadow-md" data-id="element-46">
      <button onClick={onToggle} className="flex w-full items-center justify-between p-6 text-left transition-colors hover:bg-gray-50" aria-expanded={isOpen} data-id="element-47">
        <span className="pr-4 font-heading text-lg font-bold text-gray-900" data-id="element-48">
          {question}
        </span>
        <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-electric-blue/10 to-bright-orange/10" data-id="element-49">
          {isOpen ? <MinusIcon className="h-5 w-5 text-electric-blue" data-id="element-50" /> : <PlusIcon className="h-5 w-5 text-electric-blue" data-id="element-51" />}
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-52">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-53">
            <div className="border-t border-gray-100 px-6 pb-6 pt-4" data-id="element-54">
              <p className="text-gray-600" data-id="element-55">
                {'Tienes acceso de por vida al curso. Podr\xE1s ingresar cuando quieras y ver las clases a tu propio ritmo, sin l\xEDmite de tiempo.'}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-56">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-57"></div>
    </section>;
}